import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "select", "email"]

  open(event) {
    const trigger = event.currentTarget
    const userId = trigger.dataset.userId
    const userEmail = trigger.dataset.userEmail
    const roleId = trigger.dataset.roleId

    this.selectTarget.value = roleId || ""
    this.dialogTarget.querySelector("form").action = `/backoffice/users/${userId}`
    this.emailTarget.textContent = userEmail
    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }

  close() {
    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }
}
